import {
  EVENTS_LOAD_DATASOURCES_IN_EVENT_BEGIN,
  EVENTS_LOAD_DATASOURCES_IN_EVENT_SUCCESS,
  EVENTS_LOAD_DATASOURCES_IN_EVENT_FAILURE,
  EVENTS_LOAD_DATASOURCES_IN_EVENT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export function loadDatasourcesInEvent(args = {}) {
  return (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: EVENTS_LOAD_DATASOURCES_IN_EVENT_BEGIN,
    });

    const { projectId, version } = args;
    let header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      let url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/get-externaldb`;
      if (args.type) {
        url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/get-externaldb?type=${args.type}`;
      } else if (args.types) {
        url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/external-api/get-externaldb?types=${args.types}`;
      }
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: EVENTS_LOAD_DATASOURCES_IN_EVENT_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: EVENTS_LOAD_DATASOURCES_IN_EVENT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissLoadDatasourcesInEventError() {
  return {
    type: EVENTS_LOAD_DATASOURCES_IN_EVENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case EVENTS_LOAD_DATASOURCES_IN_EVENT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        loadDatasourcesInEventPending: true,
        loadDatasourcesInEventError: null,
      };

    case EVENTS_LOAD_DATASOURCES_IN_EVENT_SUCCESS:
      // The request is success
      return {
        ...state,
        loadDatasourcesInEventPending: false,
        loadDatasourcesInEventError: null,
        dataSources: action.data,
      };

    case EVENTS_LOAD_DATASOURCES_IN_EVENT_FAILURE:
      // The request is failed
      return {
        ...state,
        loadDatasourcesInEventPending: false,
        loadDatasourcesInEventError: action.data.error,
      };

    case EVENTS_LOAD_DATASOURCES_IN_EVENT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        loadDatasourcesInEventError: null,
      };

    default:
      return state;
  }
}
